import RiseApiSerializer from 'rise-ui/serializers/application.js';

import { camelize } from '@ember/string';

import { includeOnlyRelationships } from 'rise-ui/utils/serializer/include-only-relationships.js';

const matchApiPath = /^.*\/(?=[^/]+)/;
const extractId = id => id.replace(matchApiPath, '');

/**
 * Base serializer for ember-data requests to API server
 */
@includeOnlyRelationships
export default class DataSerializer extends RiseApiSerializer {
  extractId(modelClass, resourceHash) {
    return String(resourceHash.attributes?._id || super.extractId(...arguments));
  }

  extractRelationship(relationshipHash) {
    relationshipHash?.data && [].concat(relationshipHash.data).forEach(data => {
      data.id = typeof data.id === 'string' ? extractId(data.id)
        // Sometimes we get a relationship with an integer ID and I literally
        // have no idea why; chalking it up to a bug in ember-data at the time.
        : String(data.id);
        // : data.id;
    });
    return super.extractRelationship(...arguments);
  }

  modelNameFromPayloadKey(key) {
    key = super.modelNameFromPayloadKey(...arguments);
    key = {
      // remoteModelName: 'localModelName',
      'catalog-item':       'item',
      'catalog-theme-type': 'catalog-theme',
    }[key] || key;
    return key;
  }

  keyForAttribute(key) {
    key = {
      // localAttributeKey: 'remoteAttributeKey',
    }[key] || key;
    return camelize(key);
  }

  keyForRelationship(key) {
    key = {
      // localRelationshipAttributeKey: 'remoteRelationshipKey',
    }[key] || key;
    return camelize(key);
  }
}
